export function hasValidAddress({ address }) {
    return (
        address &&
        address.city &&
        address.line1 &&
        address.state &&
        address.zipcode
    );
}
